import { Link, useHistory } from "react-router-dom";
import { GET_PARAMS, GET_POPUPS } from "../const/router";
import usePrepareLink from "../hooks/usePrepareLink";

export interface EmptyCarpetResultProps {
  imgSrc: string;
  title: string;
  subTitle: string;
  secondSubTitle?: string;
}

const EmptyCarpetResult = ({
  imgSrc,
  title,
  subTitle,
  secondSubTitle = "",
}: EmptyCarpetResultProps) => {
  const history = useHistory();

  return (
    <div
      style={{
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={imgSrc}
        loading="lazy"
        style={{ width: "170px", minWidth: "0px" }}
      />
      <div style={{ textAlign: "center" }}>
        <h1>{title}</h1>
        <p>{subTitle}</p>
        {secondSubTitle && (
          <>
            <br />
            <p>{secondSubTitle}</p>
          </>
        )}

        <div
          className="gallery_prof_info status"
          style={{ display: "flex", alignItems: "center" }}
        >
          <button
            name="btn-go-back-users-search"
            className="button"
            style={{ minWidth: "300px" }}
            onClick={() => history.goBack()}
          >
            <span>חיפוש חדש</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmptyCarpetResult;
